import { IconButton, Tooltip } from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import { useState } from "react";
import PayrollModal from "components/PayrollModal";

const ShiftJobsExportButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Tooltip title="Shift Job Export">
        <IconButton color="info" onClick={() => setIsModalOpen(true)}>
          <FileDownload />
        </IconButton>
      </Tooltip>
      {isModalOpen && (
        <PayrollModal isOpen={isModalOpen} toggleOpen={setIsModalOpen} type="shiftJobs" />
      )}
    </>
  );
};

export default ShiftJobsExportButton;
